module.exports = __webpack_public_path__ + "img/worm-attack-01.c2394f33.png";